import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AocClasses, ICharacter } from '@pvplevelup/core/dist/interfaces/ICharacter';
import { NavLink } from 'react-router-dom';
import { classImages } from 'utilities/ClassImages';
import { ClassColorsObject } from 'utilities/team_colors';
import { ICharacterStats } from '../../../../core/src/interfaces/ICharacter';
import { ProfileHeader, rankValue, mmrValue } from 'components/Profile/ProfileHeader';

interface Props {
  character: ICharacter | undefined | null;
  characterStats: ICharacterStats | undefined;
  fieldStats: ICharacterStats | undefined;
  lastGame: string;
}

const useStyles = makeStyles((theme) => {
	return {
    userlink:{
      textDecoration: "none",
      color: "#fff",
      fontWeight: 600,
      "&:hover,&:focus": {
        textDecoration: "underline",
      }
    }
	};
});

const CharacterHeader: React.FC<Props> = ({character, lastGame,characterStats,fieldStats}) => {
  const classes = useStyles();

  let characterClass = character ? character.class : "";
  const classColor = characterClass ? (ClassColorsObject as Record<string, string>)[characterClass] : undefined;

	return (
    <ProfileHeader
      image={classImages.getColorIcon(characterClass as AocClasses)}
      accent={classColor}
      title={character?.name}
      subtitle={
        <span>
          <span style={{color: classColor, fontWeight: 600}}>{[character?.level ? `Level ${character.level}` : null, characterClass].filter((x) => x).join(' ')}</span>
          {character?.server && <span> · {character.server}</span>}
          {character?.user?._id && <span> · <NavLink className={classes.userlink} to={`/users/${character.user._id}`}>{character.user.displayname}</NavLink></span>}
        </span>
      }
      meta={lastGame ? `Last game ${lastGame}` : 'No games yet'}
      stats={[
        {label: 'Ranked Rank', value: rankValue(character?.ranked_ranking)},
        {label: 'Ranked MMR', value: mmrValue(character?.ranked_mmr)},
        {label: 'Unranked Rank', value: rankValue(character?.unranked_ranking)},
        {label: 'Unranked MMR', value: mmrValue(character?.unranked_mmr)},
      ]}
    />
	);
};

export {CharacterHeader};
